const Hero = () => {
  return (
    <section id="hero" className="hero section light-background">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-12 order-2 order-lg-1 d-flex flex-column justify-content-center text-lg-center text-start" data-aos="zoom-out">
            <img src="img/herologo.png" alt="herologo" width={800} className="img-fluid mx-auto d-block mb-5" />
            <h3 className="mt-5 text-primary">Soluzioni tecnologiche per la  sicurezza e l’intelligenza artificiale</h3>
            <p>Tecnologie digitali progettate per supportare organizzazioni che operano in contesti critici e ad alta affidabilità.</p>
            <div className="d-flex mx-lg-auto  mx-0 mt-5">
              <a href="#services" className="btn-get-started">I nostri servizi</a>
              <a href="#featured-services" className="btn-watch-video d-flex align-items-center"><span>Contattaci</span></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Hero;